import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../Themes/colors';
export var FilterPanelWrapper = styled(Box)({
    width: '100%',
    flexShrink: 0,
    backgroundColor: baseColors.fullWhite,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
});
export var FilterHeader = styled(Box)({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 16px 10px',
});
export var FilterBody = styled(Box)({
    overflowY: 'auto',
    height: 'calc(100vh - 416px)',
    minHeight: 'calc(100vh - 300px)',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    '&::-webkit-scrollbar': { width: 3 },
    '&::-webkit-scrollbar-thumb': {
        background: baseColors.greyPreset[40],
        borderRadius: '4px',
    },
});
export var FilterSection = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& .filter-section-label': {
        fontSize: 14,
        fontWeight: 500,
        color: baseColors.greyPreset[5],
    },
});
export var StatusChipGroup = styled(Box)({
    gap: 8,
    display: 'flex',
    flexWrap: 'wrap',
});
export var StatusChip = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'selected'; },
})(function (_a) {
    var selected = _a.selected;
    return ({
        minWidth: 75,
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: 14,
        lineHeight: 1.2,
        fontWeight: 500,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        border: "1px solid ".concat(selected ? baseColors.bluePreset[70] : 'transparent'),
        backgroundColor: selected ? baseColors.bluePreset[60] : baseColors.greyPreset[55],
        color: selected ? baseColors.bluePreset[50] : baseColors.bluePreset[40],
        transition: 'all 0.15s ease',
        '&:hover': {
            borderColor: baseColors.bluePreset[70],
            backgroundColor: baseColors.bluePreset[60],
        },
    });
});
export var FilterFooter = styled(Box)({
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '12px',
    borderTop: "1px solid ".concat(baseColors.greyPreset[40]),
});
export var FilterFooterActions = styled(Box)({
    display: 'flex',
    gap: 8,
    width: '100%',
});
export var SavedFilterSelect = styled(Box)({
    '& .MuiSelect-select': {
        fontSize: 13,
        color: baseColors.greyPreset[10],
    },
});
